import { getDay } from 'date-fns';
import { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../constents';

function DatePickerCalander({
  selectedDate,
  setSelectedDate,
  editFlag,
  closeDays = [],
  excludeDates = [],
  highlightDates = [],
  className = 'date-picker-calander',
  minDate = new Date(new Date().getFullYear() - 120, 0, 1), // 120 years ago
  maxDate = new Date(new Date().getFullYear() + 100, 0, 1), // 100 years later
  containerDivStyle = {},

  ...props
}) {
  const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);
  function openDatePicker() {
    if (editFlag) return;
    setDatePickerIsOpen(!datePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setDatePickerIsOpen(!datePickerIsOpen);
  }
  return (
    <div className="flex-sec item-center" style={containerDivStyle}>
      <ReactDatePicker
        onChangeRaw={() => {
          if (!datePickerIsOpen) setDatePickerIsOpen(true);
        }}
        onInputClick={() => {
          if (!datePickerIsOpen) setDatePickerIsOpen(true);
        }}
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        onClickOutside={openDatePicker}
        open={datePickerIsOpen}
        onSelect={handleDateSelect}
        className={className}
        filterDate={(date) => {
          const day = getDay(date);
          return !closeDays.includes(day);
        }}
        dateFormat={DEFAULT_DATE_FORMATE}
        excludeDates={excludeDates}
        highlightDates={highlightDates}
        disabled={editFlag}
        placeholderText="mm - dd - yyyy"
        minDate={minDate}
        maxDate={maxDate}
        {...props}
      />
      <img
        width="35px"
        src="./images/calendar-icon.png"
        alt=""
        onClick={openDatePicker}
        style={{ cursor: 'pointer', marginLeft: '5px' }}
      />
    </div>
  );
}

export default DatePickerCalander;
